import { DropDownList } from '@progress/kendo-react-dropdowns'
import { loadMessages, LocalizationProvider } from '@progress/kendo-react-intl'
import CustomText from 'components/text/CustomText'
import { useState } from 'react'
import styled from 'styled-components'
import { IDropdownOption, TDropdown } from 'types'
import trMessages from './shared-dd-tr'
import enMessages from './shared-dd-en'
import arMessages from './shared-dd-ar'
import { useAppSelector } from 'app/hooks'
loadMessages(trMessages, 'tr')
loadMessages(enMessages, 'en')
loadMessages(arMessages, 'ar')

interface IDropdownProps {
  id: string
  selectedOption: IDropdownOption
  options: TDropdown
  onChangeOption: (params: IDropdownOption) => void
  className?: string
  title?: string
  disabled?: boolean
  defaultItem?: { title: string }
  style?: React.CSSProperties
}

const Dropdown = ({
  id,
  selectedOption,
  options,
  onChangeOption,
  title,
  className,
  disabled,
  defaultItem,
  style
}: IDropdownProps) => {
  const [visible, setVisible] = useState(false)

  const notificationLanguage =
    useAppSelector((state) => state?.auth?.user?.notificationLanguage) || 'tr'

  const ontoggleOption = () => {
    if (!disabled) {
      setVisible((prevState) => !prevState)
    }
  }

  return (
    <>
      <LocalizationProvider
        language={`${notificationLanguage}-${notificationLanguage?.toUpperCase()}`}
      >
        <DrowdownContainer className={className} onClick={ontoggleOption}>
          {title && (
            <TitleWrapper>
              <CustomText typography="header3">{title}</CustomText>
            </TitleWrapper>
          )}
          <DropDownList
            id={id}
            data={options}
            textField="title"
            dataItemKey="value"
            value={selectedOption}
            defaultItem={defaultItem}
            style={style}
            onChange={(e) => onChangeOption(e.target.value)}
          />
        </DrowdownContainer>
        {visible && <BackDrop />}
      </LocalizationProvider>
    </>
  )
}

export default Dropdown

const BackDrop = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  z-index: 1;
  pointer-events: none;
`

const DrowdownContainer = styled.div`
  gap: 3px;
  position: relative;
  z-index: 4;
`

const TitleWrapper = styled.div`
  gap: 3px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 8px;
`
